import React, { useState, useRef } from "react";
import { AddIcon, DropdownCrossIcon, FileIcon, UploadIcon } from "../Icons";

const RequiredDocFileUpload = ({
  name,
  id,
  onChange,
  title,
  isMultiple,
  maxCount,
  mandatory,
  error
}) => {
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles].slice(0, maxCount));
    if (onChange) {
      onChange(name, [...files, ...selectedFiles]);
    }
    fileInputRef.current.value = "";
  };

  const clearFile = (fileIndex) => {
    const updatedFiles = files.filter((_, index) => index !== fileIndex);
    setFiles(updatedFiles);
    if (onChange) {
      
      onChange(name, updatedFiles);
    }
  };  

  return (
    <div
      className={`relative w-full px-3 py-2 rounded-xl border
        ${files.length > 0 ? "multiple-upload-wrapper-has-files" : "border-divider"}
        ${error.includes(name) ? "multiple-upload-wrapper-error" : "multiple-upload-wrapper-default"}
        shadow-sm multiple-upload-wrapper
      `}
    >
      <div
        className={`flex items-center 
        ${
          files.length > 0
            ? "multiple-upload-header-filled rounded-lg px-2 py-2"
            : "multiple-upload-header-default"
        }
      `}
      >
        <div className="flex-shrink-0">
          <UploadIcon />
        </div>
        <label
          htmlFor={id}
          className={`items-center justify-between pl-2 text-xs font-medium multiple-upload-label`}>
          {title} {mandatory === 1 && <span className="text-red-500 font-semibold">( * required )</span>}
        </label>
        <input
          ref={fileInputRef}
          type="file"
          id={id}
          name={name}
          className="hidden cursor-pointer"
          multiple={isMultiple}
          onChange={handleFileChange}
          disabled={files.length >= maxCount}
        />
      </div>
      {!files.length && (
        <label
          htmlFor={id}
          className="font-normal cursor-pointer flex items-center ml-7 mt-1 text-xs multiple-upload-label-secondary"
        >
          Upload documents
        </label>
      )}
      {files.length > 0 && (
        <div className="mt-2 grid grid-cols-1 max-sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4">
          <>
            {files.map((file, index) => (
              <div
                key={index}
                className="multiple-upload-file-item"
              >
                <FileIcon />
                <p className="multiple-upload-file-name">
                  {file.name}
                </p>
                <DropdownCrossIcon onClick={() => clearFile(index)} />
              </div>
            ))}
            {maxCount > files.length && (
              <label
                htmlFor={id}
                className="multiple-upload-add-more"
              >
                Add more <AddIcon />
              </label>
            )}
          </>
        </div>
      )}
    </div>
  );
};

export default RequiredDocFileUpload;
